import React from 'react';
import { HighlightsPanel } from './components/HighlightsPanel/HighlightsPanel';
import { loan } from './data/loan';
interface AppProps {
  userRole?: 'admin' | 'viewer';
  startInEditMode?: boolean;
  statusRules?: boolean;
}
export function App({
  userRole = 'admin',
  startInEditMode = false,
  statusRules = true
}: AppProps) {
  return <main className="min-h-full w-full bg-[#eef3fb] p-3.5" data-id="element-0" data-mp="3fb9j7afffcn3">
      <HighlightsPanel key={`${userRole}-${startInEditMode}`} loan={loan} rulesEnabled={statusRules} canConfigure={userRole === 'admin'} defaultEditing={startInEditMode} data-id="element-1" data-mp="2rk46h44s90h0" />
    </main>;
}